export enum TextboxVariant {
    OUTLINED = "outlined",
    UNDERLINED = "underlined",
    NO_LINES = "noLines"
}
